import type { ReactNode } from "react";
import { Link } from "react-router";
import styles from "./BottomTabs.module.css";

interface NavItem {
  readonly href: string;
  readonly icon: ReactNode;
  readonly label: string;
}

interface BottomTabsProps {
  readonly navItems: readonly NavItem[];
  readonly activeHref: string;
}

export function BottomTabs({ navItems, activeHref }: BottomTabsProps) {
  return (
    <nav className={styles.tabs} aria-label="Main navigation">
      {navItems.map(({ href, icon, label }) => {
        const isActive = href === activeHref || (href !== "/dashboard" && activeHref.startsWith(href + "/"));
        return (
          <Link
            key={href}
            to={href}
            className={`${styles.tab} ${isActive ? styles.tabActive : ""}`}
            aria-current={isActive ? "page" : undefined}
          >
            <span className={styles.tabIcon}>{icon}</span>
            <span className={styles.tabLabel}>{label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
